// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__e6LQ7","title":"InfoRow_title__2VBUN"};